<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>弹窗配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:popUp:addLevel']" size="mini" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <clear-cache-apply />
            <sync-data />
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="积分">
                <el-input v-model.number="scoreFormData.min_score" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="scoreFormData.max_score" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="saveScoreEvent()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent('firstLogin', tabItem.label)">+积分</el-button>
              <el-tab-pane label="首次登录" name="first">
                <el-form>
                  <div v-if="formData.hasOwnProperty(tabItem.label)">
                    <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix" style="height: 40px;">
                          <el-form :inline="true">
                            <el-form-item label="积分">
                              <el-input v-model.number="scoreItem.min_score" style="width: 100px;" placeholder="最小值" @change="(v)=>{return scoreChange(v, 1,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                            <el-form-item label="-">
                              <el-input v-model.number="scoreItem.max_score" style="width: 100px;" placeholder="最大值" @change="(v)=>{return scoreChange(v, 0,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                          </el-form>
                        </div>
                        <el-form :inline="true">
                          <el-row v-for="(item, score_index) in scoreItem.data['firstLogin']" :key="score_index">
                            <el-form-item label="优先级">
                              <el-input v-model.number="item.priority" style="width: 100px;" placeholder="优先级" />
                            </el-form-item>
                            <el-form-item label="分组">
                              <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                            </el-form-item>
                            <el-form-item label="弹窗类型">
                              <el-select v-model="item.pop_type" placeholder="请选择">
                                <el-option
                                  v-for="item in popType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="是否必现">
                              <el-select v-model.number="item.is_require" placeholder="请选择">
                                <el-option
                                  v-for="iitem in appearType"
                                  :key="iitem.value"
                                  :label="iitem.label"
                                  :value="iitem.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="概率">
                              <el-input v-model.number="item.weight" :disabled="item.is_require === 1" style="width: 100px;" placeholder="概率" />
                            </el-form-item>
                            <el-form-item>
                              <el-button v-permisaction="['config:popUp:add']" type="danger" @click="delEvent('firstLogin', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak , score_index,item.id)">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button type="primary" @click="addEvent('firstLogin', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak)">+</el-button>
                          <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfGameplay')">保存</el-button>
                        </el-form>
                      </el-card>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="当日非首次" name="second">
                <el-form>
                  <div v-if="formData.hasOwnProperty(tabItem.label)">
                    <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix" style="height: 40px;">
                          <el-form :inline="true">
                            <el-form-item label="积分">
                              <el-input v-model.number="scoreItem.min_score" style="width: 100px;" placeholder="最小值" @change="(v)=>{return scoreChange(v, 1,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                            <el-form-item label="-">
                              <el-input v-model.number="scoreItem.max_score" style="width: 100px;" placeholder="最大值" @change="(v)=>{return scoreChange(v, 0,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                          </el-form>
                        </div>
                        <el-form :inline="true">
                          <el-row v-for="(item, score_index) in scoreItem.data['noFirstLogin']" :key="score_index">
                            <el-form-item label="优先级">
                              <el-input v-model.number="item.priority" style="width: 100px;" placeholder="优先级" />
                            </el-form-item>
                            <el-form-item label="分组">
                              <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                            </el-form-item>
                            <el-form-item label="弹窗类型">
                              <el-select v-model="item.pop_type" placeholder="请选择">
                                <el-option
                                  v-for="item in popType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="是否必现">
                              <el-select v-model.number="item.is_require" placeholder="请选择">
                                <el-option
                                  v-for="iitem in appearType"
                                  :key="iitem.value"
                                  :label="iitem.label"
                                  :value="iitem.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="概率">
                              <el-input v-model.number="item.weight" :disabled="item.is_require === 1" style="width: 100px;" placeholder="概率" />
                            </el-form-item>
                            <el-form-item>
                              <el-button v-permisaction="['config:popUp:add']" type="danger" @click="delEvent('noFirstLogin', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak , score_index,item.id)">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button type="primary" @click="addEvent('noFirstLogin', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak)">+</el-button>
                          <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfGameplay')">保存</el-button>
                        </el-form>
                      </el-card>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="骰子破产" name="third">
                <el-form>
                  <div v-if="formData.hasOwnProperty(tabItem.label)">
                    <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix" style="height: 40px;">
                          <el-form :inline="true">
                            <el-form-item label="积分">
                              <el-input v-model.number="scoreItem.min_score" style="width: 100px;" placeholder="最小值" @change="(v)=>{return scoreChange(v, 1,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                            <el-form-item label="-">
                              <el-input v-model.number="scoreItem.max_score" style="width: 100px;" placeholder="最大值" @change="(v)=>{return scoreChange(v, 0,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                          </el-form>
                        </div>
                        <el-form :inline="true">
                          <el-row v-for="(item, score_index) in scoreItem.data['sieveBankruptcy']" :key="score_index">
                            <el-form-item label="优先级">
                              <el-input v-model.number="item.priority" style="width: 100px;" placeholder="优先级" />
                            </el-form-item>
                            <el-form-item label="分组">
                              <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                            </el-form-item>
                            <el-form-item label="弹窗类型">
                              <el-select v-model="item.pop_type" placeholder="请选择">
                                <el-option
                                  v-for="item in popType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="是否必现">
                              <el-select v-model.number="item.is_require" placeholder="请选择">
                                <el-option
                                  v-for="iitem in appearType"
                                  :key="iitem.value"
                                  :label="iitem.label"
                                  :value="iitem.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="概率">
                              <el-input v-model.number="item.weight" :disabled="item.is_require === 1" style="width: 100px;" placeholder="概率" />
                            </el-form-item>
                            <el-form-item>
                              <el-button v-permisaction="['config:popUp:add']" type="danger" @click="delEvent('sieveBankruptcy', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak , score_index,item.id)">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button type="primary" @click="addEvent('sieveBankruptcy', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak)">+</el-button>
                          <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfGameplay')">保存</el-button>
                        </el-form>
                      </el-card>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="钞票破产" name="fourth">
                <el-form>
                  <div v-if="formData.hasOwnProperty(tabItem.label)">
                    <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix" style="height: 40px;">
                          <el-form :inline="true">
                            <el-form-item label="积分">
                              <el-input v-model.number="scoreItem.min_score" style="width: 100px;" placeholder="最小值" @change="(v)=>{return scoreChange(v, 1,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                            <el-form-item label="-">
                              <el-input v-model.number="scoreItem.max_score" style="width: 100px;" placeholder="最大值" @change="(v)=>{return scoreChange(v, 0,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                          </el-form>
                        </div>
                        <el-form :inline="true">
                          <el-row v-for="(item, score_index) in scoreItem.data['bankruptcyOfBanknotes']" :key="score_index">
                            <el-form-item label="优先级">
                              <el-input v-model.number="item.priority" style="width: 100px;" placeholder="优先级" />
                            </el-form-item>
                            <el-form-item label="分组">
                              <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                            </el-form-item>
                            <el-form-item label="弹窗类型">
                              <el-select v-model="item.pop_type" placeholder="请选择">
                                <el-option
                                  v-for="item in popType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="是否必现">
                              <el-select v-model.number="item.is_require" placeholder="请选择">
                                <el-option
                                  v-for="iitem in appearType"
                                  :key="iitem.value"
                                  :label="iitem.label"
                                  :value="iitem.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="概率">
                              <el-input v-model.number="item.weight" :disabled="item.is_require === 1" style="width: 100px;" placeholder="概率" />
                            </el-form-item>
                            <el-form-item>
                              <el-button v-permisaction="['config:popUp:add']" type="danger" @click="delEvent('bankruptcyOfBanknotes', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak , score_index,item.id)">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button type="primary" @click="addEvent('bankruptcyOfBanknotes', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak)">+</el-button>
                          <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfGameplay')">保存</el-button>
                        </el-form>
                      </el-card>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="玩法破产" name="fiftieth">
                <el-form>
                  <div v-if="formData.hasOwnProperty(tabItem.label)">
                    <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                      <el-card class="box-card" style="margin-top: 10px">
                        <div slot="header" class="clearfix" style="height: 40px;">
                          <el-form :inline="true">
                            <el-form-item label="积分">
                              <el-input v-model.number="scoreItem.min_score" style="width: 100px;" placeholder="最小值" @change="(v)=>{return scoreChange(v, 1,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                            <el-form-item label="-">
                              <el-input v-model.number="scoreItem.max_score" style="width: 100px;" placeholder="最大值" @change="(v)=>{return scoreChange(v, 0,tabItem.label,scoreItem.min_score_bak, scoreItem.max_score_bak)}" />
                            </el-form-item>
                          </el-form>
                        </div>
                        <el-form :inline="true">
                          <el-row v-for="(item, score_index) in scoreItem.data['bankruptcyOfGameplay']" :key="score_index">
                            <el-form-item label="优先级">
                              <el-input v-model.number="item.priority" style="width: 100px;" placeholder="优先级" />
                            </el-form-item>
                            <el-form-item label="分组">
                              <el-input v-model.number="item.group" style="width: 100px;" placeholder="分组" />
                            </el-form-item>
                            <el-form-item label="弹窗类型">
                              <el-select v-model="item.pop_type" placeholder="请选择">
                                <el-option
                                  v-for="item in popType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="是否必现">
                              <el-select v-model="item.is_require" placeholder="请选择">
                                <el-option
                                  v-for="iitem in appearType"
                                  :key="iitem.value"
                                  :label="iitem.label"
                                  :value="iitem.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="概率">
                              <el-input v-model.number="item.weight" :disabled="item.is_require === 1" style="width: 100px;" placeholder="概率" />
                            </el-form-item>
                            <el-form-item>
                              <el-button v-permisaction="['config:popUp:add']" type="danger" @click="delEvent('bankruptcyOfGameplay', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak , score_index,item.id)">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button type="primary" @click="addEvent('bankruptcyOfGameplay', tabItem.label,scoreItem.min_score_bak+'-'+scoreItem.max_score_bak)">+</el-button>
                          <el-button v-permisaction="['config:popUp:add']" type="primary" @click="onSubmit('bankruptcyOfGameplay')">保存</el-button>
                        </el-form>
                      </el-card>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { deletePopUpCfg, getPopUpCfg, updatePopUpCfg } from '@/api/config/pop-up-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'PopUp',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      popType: [
        { 'label': '推送更新', value: 1 },
        { 'label': '签到', value: 2 },
        { 'label': '排行榜', value: 3 },
        { 'label': '好友礼物列表', value: 4 },
        { 'label': '好友邀请', value: 5 },
        { 'label': '6格连环礼包', value: 6 },
        { 'label': '3格连环礼包', value: 7 },
        { 'label': '通行证', value: 8 },
        { 'label': '首充礼包', value: 9 },
        { 'label': '绑定FB弹窗', value: 10 },
        { 'label': '都市礼包', value: 11 },
        { 'label': '体力大师', value: 12 },
        { 'label': '消息列表', value: 13 },
        { 'label': '回归礼包', value: 14 },
        { 'label': '好友召回', value: 15 },
        { 'label': '1+2礼包', value: 16 },
        { 'label': '1+6礼包', value: 17 },
        { 'label': '主题礼包', value: 18 }
      ],
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        min_score: 0,
        max_score: 0,
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {}
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      const postFormData = {}
      for (const i in formData) {
        let scoreIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          scoreIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + scoreIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          if (scoreItem.min_score > scoreItem.max_score) {
            this.msgError('最低积分不能大于最高积分')
            return
          }
          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            scores: [parseInt(scoreItem.min_score), parseInt(scoreItem.max_score)]
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }
        }
      }
      const postCondition = JSON.stringify(postFormDataCondition)
      const postData = JSON.stringify(postFormData)
      console.log(postCondition)
      console.log(postData)
      updatePopUpCfg({ name: postCondition, data: postData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getPopUpCfg().then(res => {
        if (res.code === 200) {
          const data = res.data.data
          // const tab = {}
          const cond = res.data.cond
          for (const i in cond) {
            const val = cond[i]
            const levelName = val.start + '-' + val.end
            const [minScore, maxScore] = val.scores
            // eslint-disable-next-line no-unused-vars
            const scoreName = minScore + '-' + maxScore
            if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
              this.$set(this.formData, levelName, {})
            }
            console.log('levelName', levelName, 'scoreName', scoreName)
            this.$set(this.formData[levelName], scoreName, {
              min_score: minScore,
              min_score_bak: minScore,
              max_score: maxScore,
              max_score_bak: maxScore,
              data: {
                firstLogin: [],
                noFirstLogin: [],
                sieveBankruptcy: [],
                bankruptcyOfBanknotes: [],
                bankruptcyOfGameplay: []
              }
            })

            for (const ii in data) {
              const _event = data[ii]
              if (ii === i) {
                this.$set(this.formData[levelName][scoreName], 'data', _event)
              }
            }

            // 等级
            let findIndex = -1
            this.tabPane.forEach((item, index) => {
              if (item.label === levelName) {
                findIndex = index
              }
            })

            if (findIndex === -1) {
              this.tabPane.push({
                label: levelName,
                min_level: val.start,
                max_level: val.end,
                bak_min_level: val.start,
                bak_max_level: val.end,
                add: true
              })
            }

            this.levelActiveName = levelName
          }

          console.log(this.formData)
          //     this.tabPane = []
          //     for (const d in res.data) {
          //       const val = res.data[d]
          //       const [min_level, max_level] = d.split('-')
          //       this.tabPane.push({
          //         'label': d,
          //         'min_level': min_level,
          //         'max_level': max_level,
          //         'bak_min_level': min_level,
          //         'bak_max_level': max_level,
          //         'min_score': 0,
          //         'max_score': 0,
          //         add: true
          //       })
          //       console.log(val)
          //       this.$set(this.formData, d, val)
          //     }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }

      this.levelActiveName = newLevelName
    },
    addEvent(eventName, levelName, scoreName) {
      this.formData[levelName][scoreName].data[eventName].push({
        'id': 0,
        'priority': 1,
        'group': 0,
        'pop_type': 0,
        'is_require': 0,
        'weight': 0
      })
    },
    delEvent(eventName, levelName, scoreName, index, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deletePopUpCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData[levelName][scoreName].data[eventName] = this.formData[levelName][scoreName].data[eventName].filter((item, key) => {
          return index !== key
        })
      }
    },
    addScoreEvent(eventName, levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.event_name = eventName
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    saveScoreEvent() {
      this.dialogVisibleScoreEvent = false
      const score = this.scoreFormData
      console.log(score)
      const scoreTag = score.min_score + '-' + score.max_score
      if (score.min_score > score.max_score) {
        this.msgError('最小积分不能大于最大积分')
        return false
      }
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'min_score': score.min_score,
          'min_score_bak': score.min_score,
          'max_score': score.max_score,
          'max_score_bak': score.max_score,
          'data': {
            'firstLogin': [],
            'noFirstLogin': [],
            'sieveBankruptcy': [],
            'bankruptcyOfBanknotes': [],
            'bankruptcyOfGameplay': []
          }
        })
      }
      this.formData[score.level_name][scoreTag].data['firstLogin'].push({
        'id': 0,
        'priority': 1,
        'group': 0,
        'pop_type': 0,
        'is_require': 0,
        'weight': 0
      })
      console.log(this.formData)
    },
    addLevel() {
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      this.levelActiveName = levelName
      this.$set(this.formData, levelName, {})

      // {
      //   'firstLogin': {
      //   'min_level': this.levelFormData.min_level,
      //     'max_level': this.levelFormData.max_level,
      //     'min_score': 0,
      //     'max_score': 0,
      //     'data': [{
      //     'id': 0,
      //     'level': 1,
      //     'group': 0,
      //     'pop_type': 0,
      //     'is_appear': 0,
      //     'is_require': 0
      //   }]
      // }
      // }

      console.log(this.formData)
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'iconId': 0,
        'physical_reward': 0,
        'conis_reward': 0
      })
    },
    del(key, id) {
      this.formData = this.formData.filter((item, index) => {
        return index !== key
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    }
  }
}
</script>

<style scoped>
</style>
